function _arrayFromIterator(iter) {
  var list = [];
  var next;
  while (!(next = iter.next()).done) {
    list.push(next.value);
  }
  return list;
}
module.exports = _arrayFromIterator;


//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_arrayFromIterator.js
// module id = 1552
// module chunks = 0